import { Pipe, PipeTransform } from '@angular/core';
import {AgentName} from '../model/agent-name.model';

@Pipe({
  name: 'agentName'
})
export class AgentNamePipe implements PipeTransform {

  transform(agentName: AgentName): string {
    return `${agentName?._embedded?.salutation?.name ? this.getDativ(agentName._embedded.salutation.name) : ''}
            ${agentName?.firstName ? agentName.firstName : ''} ${agentName?.lastName ? agentName.lastName : ''}`;
  }

  getDativ(salutation: string) {
    return salutation === 'Herr' ? 'Herrn' : salutation;
  }
}
